var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.$wf.isMdUp
    ? _c(
        "w-row",
        {
          staticClass: "header",
          style: { padding: "10px", fontWeight: "bold" },
        },
        [
          _c("w-col", { attrs: { md: 3 } }, [
            _vm._v(_vm._s(_vm.$ct("header.document"))),
          ]),
          _c("w-col", { attrs: { md: "2" } }, [
            _vm._v(_vm._s(_vm.$ct("header.estimate-date"))),
          ]),
          _c("w-col", { attrs: { md: "2" } }, [
            _vm._v(
              _vm._s(
                _vm.isSigned
                  ? _vm.$ct("header.estimate-signed-date")
                  : _vm.$ct("header.estimate-expiration-date")
              )
            ),
          ]),
          _vm.showTotal
            ? _c("w-col", { attrs: { md: "2" } }, [
                _vm._v(
                  _vm._s(
                    _vm.isSigned
                      ? _vm.$ct("header.signed-by")
                      : _vm.$ct("header.incl")
                  )
                ),
              ])
            : _vm._e(),
          _c("w-col", { attrs: { md: "4" } }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }